import React, { useState } from "react"
import styled from "styled-components"

import Store from "@airasia/phoenix-widgets/widgets/Store"
import HotelSearchWidget from "@airasia/phoenix-widgets/widgets/HotelSearchWidget"

import HSW_DATA from "../data/phoenix/hsw-en"
import Title from "@airasia/phoenix-components/components/Title"
import Button from "@airasia/phoenix-components/components/Button"

import { DATA_TYPE } from "../utils/constants"
import { MobileViewWrapper, DesktopViewWrapper } from "../utils/styles"

// import HotelBannerImg from "../images/hotelBed.webp"
const HotelBannerImg =
  "https://static.stgairasia.com/seo/static-assets/SEOHotels/location/hotelBed.webp"

const BannerContainer = styled.div`
   {
    height: 250px;
    width: 100%;
    background: 50% 50% / cover no-repeat;
    background-position: center;
    background-image: url(${HotelBannerImg});

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    #bannerTitle {
      font-size: 1.5rem;
      margin: 10px;
    }

    @media only screen and (min-width: 768px) {
      height: 450px;

      #bannerTitle {
        margin: 1%;
        font-size: 2.5rem;
      }
    }
  }
`

const HSW_Wrapper = styled.div`
   {
    margin: 20px;
    background: white;
    padding: 40px;
    // border-radius: 20px;

    div[class^="MultiRoomSelect__DesktopModal"] {
      z-index: 99;
    }
  }
`

export default function DesktopBanner(props) {
  const { pageHeading, hsw_data, mobileBannerCta } = props
  const [showMobileHSW, setShowMobileHSW] = useState(false)

  const onMobileBannerClick = () => {
    setShowMobileHSW(true)
  }

  const onMobileHSWClose = () => {
    document.body.style.overflow = "auto"
    setShowMobileHSW(false)
  }

  let title = pageHeading

  return (
    <BannerContainer>
      <Title
        type="h1"
        color="default"
        textAlign="center"
        customProperties={{ id: "bannerTitle" }}
      >
        {title}
      </Title>

      <MobileViewWrapper>
        <Button handleClick={onMobileBannerClick}>{mobileBannerCta}</Button>
        {showMobileHSW && (
          <Store>
            <HotelSearchWidget
              currency="MYR"
              data={hsw_data.data}
              endpointConfig={hsw_data.endpointConfig}
              viewport="mobile"
              locale="en-gb"
              closeSearchWidget={onMobileHSWClose}
              environment="PRODUCTION"
            />
          </Store>
        )}
      </MobileViewWrapper>

      <DesktopViewWrapper>
        <HSW_Wrapper>
          <Store>
            <HotelSearchWidget
              currency="MYR"
              data={hsw_data.data}
              endpointConfig={hsw_data.endpointConfig}
              viewport="desktop"
              locale="en-gb"
              environment="PRODUCTION"
            />
          </Store>
        </HSW_Wrapper>
      </DesktopViewWrapper>
    </BannerContainer>
  )
}
